import { Component, OnInit, Input } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { FaxService } from '../../../shared/services/fax.service';
import { CorrespondenceTimelineService } from '../../../shared/services/correspondence-timeline.service';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-fax',
  templateUrl: './fax.component.html',
  styleUrls: ['./fax.component.scss']
})
export class FaxComponent implements OnInit {

  @Input() caseId: number;
  @Input() faxObj: any;
  @Input() caseFiles: any [] = [];

  faPaperclip = faPaperclip;
  
  sendingFax: boolean = false;
  readOnly = false;
  

  faxDetails = this.fb.group({
    faxNumber: ['', Validators.required],
    messageBody: ['', Validators.required],
    caseFileIds: null
  });

  constructor(
  public activeModal: NgbActiveModal,
  private fb: UntypedFormBuilder,
  private faxService: FaxService,
  private correspondenceTimelineService: CorrespondenceTimelineService) {
    
  }

  ngOnInit() {

     if(this.faxObj != null)
    {
      this.readOnly = true;
      this.faxDetails.controls['faxNumber'].patchValue(this.faxObj.to);
      this.faxDetails.controls['faxNumber'].disable();
      this.faxDetails.controls['messageBody'].patchValue(this.faxObj.message);
      this.faxDetails.controls['messageBody'].disable();
    }
  }

  sendFax(){

    this.sendingFax = true;

    let fileIds: any [] = [];

    this.caseFiles.forEach((file:any) => {
        fileIds.push(file.caseFileId);
    });

    this.faxDetails.controls['caseFileIds'].patchValue(fileIds);

    this.faxService.sendFax(this.caseId, this.faxDetails.value).subscribe((response : any) => {
      this.activeModal.close(true);
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });

  }

  removeAttachment(id: number){
    this.caseFiles = this.caseFiles.filter(item => item.caseFileId !== id);
  }
}
